import PerformanceForeCaster from "../../../../components/AssetManagement/Overview/PerformanceForecaster/PerformanceForeCaster";
const PerformanceForCasterScreen = () => {
  return (
    <>
      <PerformanceForeCaster />
    </>
  );
};

export default PerformanceForCasterScreen;
